import React, {useContext} from "react";
import ComputeOptimizerChangeContext from "../context/ComputeOptimizerChangeContext";

export const useComputeOptimizer = () => {
    const computeOptimizer = useContext(ComputeOptimizerChangeContext)
    return computeOptimizer
}